import axios from '../auth/authInterceptor';

/**
 * Servicio para gestionar la bandeja de mensajes (inbox)
 */


export const getConversaciones = async (page = 1, limit = 50, filter = 'all', search = '') => {
  try {
    console.log('[InboxService] Obteniendo conversaciones...', { page, limit, filter, search });

    const response = await axios.get('/api/inbox/conversations', {
      params: { page, limit, filter, search }
    });

    console.log('[InboxService] Conversaciones obtenidas:', response.data);
    return response.data;
  } catch (error) {
    console.error('[InboxService] Error obteniendo conversaciones:', error);
    throw error;
  }
};


export const getMensajes = async (leadUuid, limit = 200) => {
  try {
    console.log('[InboxService] Obteniendo mensajes para lead:', leadUuid);

    const response = await axios.get(`/api/inbox/messages/${leadUuid}`, {
      params: { limit }
    });

    console.log('[InboxService] Mensajes obtenidos:', response.data.data?.length || 0);
    return response.data;
  } catch (error) {
    console.error('[InboxService] Error obteniendo mensajes:', error);
    throw error;
  }
};


export const enviarMensaje = async (data) => {
  try {
    console.log('[InboxService] Enviando mensaje:', data);

    const response = await axios.post('/api/inbox/send', data);

    console.log('[InboxService] Mensaje enviado:', response.data);
    return response.data;
  } catch (error) {
    console.error('[InboxService] Error enviando mensaje:', error);
    throw error;
  }
};


export const subirArchivo = async (file, leadUuid, contenido = '') => {
  try {
    console.log('[InboxService] Subiendo archivo:', file.name);

    const formData = new FormData();
    formData.append('file', file);
    formData.append('leadUuid', leadUuid);
    formData.append('contenido', contenido);

    const response = await axios.post('/api/inbox/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });

    console.log('[InboxService] Archivo subido:', response.data);
    return response.data;
  } catch (error) {
    console.error('[InboxService] Error subiendo archivo:', error);
    throw error;
  }
};

export const checkBotStatus = async (leadUuid) => {
  try {
    const response = await axios.get(`/api/inbox/bot/status/${leadUuid}`);
    return response.data;
  } catch (error) {
    console.error('[InboxService] Error checking bot status:', error);
    return { paused: false };
  }
};

export const pauseBot = async (leadUuid) => {
  try {
    const response = await axios.post(`/api/inbox/bot/pause/${leadUuid}`);
    return response.data;
  } catch (error) {
    console.error('[InboxService] Error pausing bot:', error);
    throw error;
  }
};

export const unpauseBot = async (leadUuid) => {
  try {
    const response = await axios.post(`/api/inbox/bot/unpause/${leadUuid}`);
    return response.data;
  } catch (error) {
    console.error('[InboxService] Error unpausing bot:', error);
    throw error;
  }
};

export default {
  getConversaciones,
  getMensajes,
  enviarMensaje,
  subirArchivo,
  checkBotStatus,
  pauseBot,
  unpauseBot
};
